import React from "react";
import Button from "@components/tailwindComponents/Button";
import ListboxEmploye from "@components/tailwindComponents/ListboxEmploye";
import ListboxSimple from "@components/tailwindComponents/ListboxSimple";
import ListboxGroupe from "@components/tailwindComponents/ListboxGroupe/index";
import ListBoxWithStatus from "@components/tailwindComponents/ListBoxWithStatus";

export default function ExportFilterHeader({
  t,
  employers,
  emplacements,
  groupes,
  statutListTranslated,
  selectedEmploye,
  setSelectedEmploye,
  selectedEmplacement,
  setSelectedEmplacement,
  selectedGroupe,
  setSelectedGroupe,
  selectedStatut,
  setSelectedStatut,
  applyFilter
}) {
  return (
    <div className="arh-grid arh-w-full arh-grid-cols-5 arh-items-center arh-gap-4 arh-rounded arh-bg-greyColor arh-p-4 desktop-middle:arh-gap-5">
      <ListboxEmploye
        placeholder={t("Employés")}
        name="employe"
        optionList={employers || []}
        selectedValue={selectedEmploye}
        setSelectedValue={setSelectedEmploye}
        multiple
        showReset
      />
      <ListboxSimple
        placeholder={t("Emplacement")}
        name="emplacement"
        optionList={emplacements || []}
        selectedValue={[...selectedEmplacement]}
        setSelectedValue={setSelectedEmplacement}
        multiple
        showReset
      />
      <ListboxGroupe
        placeholder={t("Groupes")}
        name="Groupes"
        optionList={groupes}
        selectedValue={selectedGroupe}
        setSelectedValue={setSelectedGroupe}
        showReset
      />
      <ListBoxWithStatus
        placeholder={t("Statut")}
        name="status"
        optionList={statutListTranslated}
        selectedValue={selectedStatut}
        setSelectedValue={setSelectedStatut}
        showReset
        toRight={true}
        multiple
        customTranslator={t}
      />
      <Button onClick={applyFilter}>{t("Appliquer")}</Button>
    </div>
  );
}
